import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { useAssetLookup } from "../api/useAssetLookup";
import { AssetIcon } from "../components/AssetIcon";
import { FightDeathMoments } from "./FightDeathMoments";
import { fightMomentText } from "./fightMomentText";
import { FindingCard } from "./FindingCard";
import type { FindingProps } from "./FindingProps";
import { iconSize } from "./iconSize";

const TITLE = msg({
  id: "finding.died_alone",
  message: "{deaths, plural, one {# death} other {# deaths}} fighting without allies",
});

const DETAILS = msg({
  id: "finding.died_alone.details",
  message:
    "That is {deaths} of your {totalDeaths, plural, one {# death} other {# deaths}}. You fought with no ally nearby — stay closer to the team or back off.",
});

// Игрок дрался с врагами без союзников рядом и погиб. Иконка — убийца в первой такой смерти.
export const DiedAlone = ({ finding, variant }: FindingProps<"died_alone">) => {
  const { i18n } = useLingui();
  const { deaths, total_deaths: totalDeaths, moments } = finding.params;
  const killer = useAssetLookup("heroes")(moments[0]?.killer_hero_id ?? 0);
  return (
    <FindingCard
      code={finding.code}
      severity={finding.severity}
      variant={variant}
      icon={<AssetIcon asset={killer} size={iconSize(variant)} />}
      title={i18n._({ ...TITLE, values: { deaths } })}
      details={i18n._({ ...DETAILS, values: { deaths, totalDeaths } })}
      summary={moments.map((moment) => fightMomentText(moment, i18n)).join(" · ")}
    >
      <FightDeathMoments moments={moments} />
    </FindingCard>
  );
};
